import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import { FiBox } from "react-icons/fi";
import { FiActivity } from "react-icons/fi";
import { FiPause } from "react-icons/fi";
import { FiLayers } from "react-icons/fi";

const PlansSummary = () => {
  const cards = [
    {
      title: "Total Plans",
      value: "08",
      bg: "#f97316",
      icon: <FiBox size={18} color="#fff" />,
    },
    {
      title: "Active Plans",
      value: "08",
      bg: "#22c55e",
      icon: <FiActivity size={18} color="#fff" />,
    },
    {
      title: "Inactive Plans",
      value: "0",
      bg: "#ef4444",
      icon: <FiPause size={18} color="#fff" />,
    },
    {
      title: "No of Plan Types",
      value: "02",
      bg: "#06b6d4",
      icon: <FiLayers size={18} color="#fff" />,
    },
  ];

  return (
    <Row className="">
      {cards.map((item, index) => (
        <Col lg={3} md={6} key={index} className="d-flex mb-3">
          <Card
            style={{
              width: "100%",
              borderRadius: "8px",
              border: "1px solid #e5e7eb",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            }}
          >
            <Card.Body
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "20px",
              }}
            >
              <div>
                <p
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    marginBottom: "6px",
                    color: "#6b7280",
                  }}
                >
                  {item.title}
                </p>

                <h4
                  style={{
                    margin: 0,
                    fontWeight: "600",
                    color: "#1f2937",
                  }}
                >
                  {item.value}
                </h4>
              </div>

              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "8px",
                  background: item.bg,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {item.icon}
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default PlansSummary;